import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomReportIssueFormModel } from "@tCooneyBrothers/ApiModels";
import { addCustomReportIssueFields as addCustomReportIssueApi } from "@tCooneyBrothers/Services/CustomReportIssueService";
import { CustomApiHandler } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<CustomReportIssueFormModel, CustomReportIssueFormModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addCustomReportIssueApi(props.parameter);
};

export const DispatchCustomReportIssueFields: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomReportIssueFields/fields",
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCustomReportIssueFields];

const addCustomReportIssueFormFields = createHandlerChainRunner(chain, "AddCustomReportIssueFields");
export default addCustomReportIssueFormFields;
